export default __webpack_public_path__ + "static/media/netwila-logo.2c49b63d.svg";